/**
 * Domain Entity: ChecklistItem
 * Represents a packing / to-do item for travel
 */
export class ChecklistItem {
  constructor({
    id = 'chk_' + Math.random().toString(36).substring(2, 9),
    text,
    completed = false,
    category = 'general', // 'preset', 'general'
    createdAt = new Date().toISOString()
  }) {
    if (!text || typeof text !== 'string') {
      throw new Error('ChecklistItem requires valid text');
    }
    this.id = id;
    this.text = text.trim();
    this.completed = completed;
    this.category = category;
    this.createdAt = createdAt;
  }

  toggle() {
    this.completed = !this.completed;
    return this.completed;
  }

  toJSON() {
    return {
      id: this.id,
      text: this.text,
      completed: this.completed,
      category: this.category,
      createdAt: this.createdAt
    };
  }

  static fromJSON(json) {
    if (!json || !json.text) return null;
    return new ChecklistItem({
      id: json.id,
      text: json.text,
      completed: !!json.completed,
      category: json.category || 'general',
      createdAt: json.createdAt || new Date().toISOString()
    });
  }
}
